var map = {
	"./Arrow.svg": "208b",
	"./Mobile.svg": "a621",
	"./Safari.svg": "347f",
	"./altering.svg": "569e",
	"./anchor_avatar.svg": "1ddd",
	"./answer-order.svg": "a23b",
	"./arrow-blue.svg": "54e9",
	"./arrow-orange.svg": "e53f",
	"./assistant_avatar.svg": "3df1",
	"./browser_err.svg": "58aa",
	"./camera.svg": "535b",
	"./camera_green.svg": "f537",
	"./camera_small.svg": "49b6",
	"./camera_small_close.svg": "c73f",
	"./camera_small_close_grey.svg": "6ce8",
	"./camera_small_disabled.svg": "47a8",
	"./camera_small_grey.svg": "16eb",
	"./change.svg": "40c0",
	"./chatavatar_6.svg": "a65a",
	"./chatavatar_7.svg": "775f",
	"./chatavatar_8.svg": "a0ca",
	"./check-box.svg": "af2b",
	"./check-radio.svg": "9994",
	"./check_err.svg": "5ade",
	"./check_pass.svg": "ae80",
	"./checkres.svg": "6433",
	"./choujiang.svg": "f724",
	"./close-answer.svg": "fd3a",
	"./close.svg": "850a",
	"./close_camera.svg": "1a13",
	"./close_local.svg": "f78f",
	"./controller.svg": "c8c1",
	"./correct.svg": "ff2b",
	"./count-down.svg": "f783",
	"./customer_service.svg": "08ef",
	"./dati.svg": "4a45",
	"./default_chatavatar.svg": "7631",
	"./del-input-ques.svg": "e79f",
	"./del-input.svg": "a825",
	"./dengfen.svg": "d27e",
	"./dianzan.svg": "37e3",
	"./doc.svg": "d116",
	"./doc_active.svg": "0ed6",
	"./doc_active_orange.svg": "0bcb",
	"./doc_orange.svg": "a61d",
	"./download_icon.svg": "dc12",
	"./drag.svg": "7ba6",
	"./exclamation.svg": "6110",
	"./file_icon.svg": "63da",
	"./file_null.svg": "797d",
	"./filter_icon.svg": "e2e8",
	"./fold.svg": "9a50",
	"./fold_orange.svg": "df1a",
	"./forceanswer.svg": "937f",
	"./gift.svg": "5805",
	"./gonggao.svg": "931f",
	"./group/group-icon.svg": "33da",
	"./group/group.svg": "d4d6",
	"./group/group_orange.svg": "02d2",
	"./guest_avatar.svg": "f624",
	"./heart-blue.svg": "09fe",
	"./heart-question.svg": "a3b1",
	"./heart.svg": "9ab4",
	"./icon-add-orange.svg": "e04e",
	"./icon-add-question.svg": "a756",
	"./icon-close-cutdown.svg": "c3c1",
	"./icon-close-light.svg": "592f",
	"./icon-del-red.svg": "80ef",
	"./icon-del-white.svg": "88fd",
	"./icon-del.svg": "f650",
	"./icon-dot-blue.svg": "4c44",
	"./icon-dot.svg": "bdb3",
	"./icon-emoji.svg": "28b0",
	"./icon-img.svg": "8728",
	"./icon-large.svg": "4741",
	"./icon-list-more.svg": "836b",
	"./icon-mini-light.svg": "9aa1",
	"./icon-mini.svg": "7292",
	"./icon-refresh-light.svg": "4d1a",
	"./icon-refresh.svg": "1081",
	"./icon-replay-light.svg": "6a52",
	"./icon-replay.svg": "a590",
	"./icon-resume-light.svg": "577b",
	"./icon-resume.svg": "c12d",
	"./icon-stop.svg": "6c19",
	"./icon-tips.svg": "61e4",
	"./icon/icon-answer.svg": "4a14",
	"./icon/icon-arrow-down.svg": "1704",
	"./icon/icon-arrow.svg": "f3d3",
	"./icon/icon-attendee.svg": "37e1",
	"./icon/icon-chat.svg": "e32d",
	"./icon/icon-check-auto.svg": "313b",
	"./icon/icon-checkin.svg": "bb48",
	"./icon/icon-clear.svg": "754f",
	"./icon/icon-clock.svg": "b8d6",
	"./icon/icon-close.svg": "784c",
	"./icon/icon-commity.svg": "0495",
	"./icon/icon-download.svg": "e6b5",
	"./icon/icon-draw.svg": "d722",
	"./icon/icon-emoji.svg": "36b6",
	"./icon/icon-fullscreen.svg": "0470",
	"./icon/icon-heart.svg": "f1bc",
	"./icon/icon-img.svg": "35f2",
	"./icon/icon-import.svg": "ffa3",
	"./icon/icon-layout-2.svg": "068f",
	"./icon/icon-layout.svg": "e727",
	"./icon/icon-list-more.svg": "30cd",
	"./icon/icon-live.svg": "2a60",
	"./icon/icon-mic.svg": "14f9",
	"./icon/icon-move-down.svg": "3829",
	"./icon/icon-move-up.svg": "c53f",
	"./icon/icon-move.svg": "6825",
	"./icon/icon-mute.svg": "07d6",
	"./icon/icon-notice.svg": "3884",
	"./icon/icon-push-all.svg": "b565",
	"./icon/icon-push.svg": "2dac",
	"./icon/icon-questionnaire.svg": "ec43",
	"./icon/icon-record.svg": "f4ca",
	"./icon/icon-recordding.svg": "f060",
	"./icon/icon-search.svg": "b2ee",
	"./icon/icon-share.svg": "3518",
	"./icon/icon-show.svg": "6f97",
	"./icon/icon-sticker.svg": "5415",
	"./icon/icon-success.svg": "55f9",
	"./icon/icon-tips.svg": "0ab9",
	"./icon/icon-viewer.svg": "5d89",
	"./icon/icon-volume.svg": "8fd4",
	"./icon/icon-word.svg": "713b",
	"./icon/icon-wx.svg": "db40",
	"./icon/no-permission-min.svg": "80d7",
	"./icon/no-permission.svg": "bad1",
	"./icon/reduce.svg": "bf0f",
	"./koulingchoujiang.svg": "dedf",
	"./layout.svg": "78ce",
	"./layout_active.svg": "33aa",
	"./layout_active_orange.svg": "2ec5",
	"./layout_disabled.svg": "e95f",
	"./layout_disabled_orange.svg": "277c",
	"./layout_orange.svg": "f65f",
	"./lianmai.svg": "3c3c",
	"./lianmai_active.svg": "b447",
	"./lianmai_active_orange.svg": "1dd2",
	"./lianmai_mute.svg": "5c6f",
	"./lianmai_mute_orange.svg": "e6c0",
	"./lianmai_orange.svg": "7375",
	"./liveTime.svg": "49ba",
	"./loading.svg": "39b1",
	"./local_set.svg": "21ee",
	"./local_setting.svg": "c506",
	"./local_video.svg": "5361",
	"./local_video_close.svg": "aabb",
	"./local_video_close2.svg": "9f43",
	"./login_name.svg": "eae2",
	"./login_pass.svg": "cb52",
	"./mic-sprite.svg": "4616",
	"./mic.svg": "0c7e",
	"./mic1.svg": "338e",
	"./mic_close.svg": "9e53",
	"./mic_close2.svg": "3b21",
	"./mic_close_0.svg": "efec",
	"./mic_green.svg": "4b56",
	"./mic_main.svg": "fb62",
	"./mic_main2.svg": "ad56",
	"./mic_open.svg": "607d",
	"./mic_small.svg": "904a",
	"./mic_small_close.svg": "395f",
	"./mic_small_close_grey.svg": "0580",
	"./mic_small_disabled.svg": "2601",
	"./mic_small_grey.svg": "3ae9",
	"./mix.svg": "9a60",
	"./mix_1.svg": "47d6",
	"./mobile-blank.svg": "368d",
	"./mobile_device.svg": "83b2",
	"./more-chat.svg": "ec34",
	"./more.svg": "976a",
	"./more_setting.svg": "c5b9",
	"./multimedia.svg": "a3b7",
	"./multimedia_active.svg": "874e",
	"./multimedia_active_orange.svg": "a27b",
	"./multimedia_orange.svg": "a46d",
	"./no-ask-light.svg": "46bf",
	"./no-ask.svg": "f4d1",
	"./no-reward.svg": "8112",
	"./no-reward_orange.svg": "23cd",
	"./nocamera.svg": "2e7c",
	"./noreceiverecord.svg": "14c0",
	"./number1.svg": "bfac",
	"./number2.svg": "e91c",
	"./number3.svg": "a60b",
	"./open-answer.svg": "990f",
	"./open.svg": "a324",
	"./open_app.svg": "68c0",
	"./open_local.svg": "34e7",
	"./option.svg": "4d9c",
	"./packup.svg": "007e",
	"./pc_device.svg": "541c",
	"./phone_icon.svg": "da77",
	"./ping.svg": "a92c",
	"./prise-blue.svg": "011f",
	"./prise-question.svg": "e658",
	"./prise.svg": "df7a",
	"./pulldown.svg": "80c7",
	"./qiandao.svg": "ba37",
	"./recomed.svg": "d3cb",
	"./record.svg": "b082",
	"./recording.svg": "2488",
	"./redpacket_bg.svg": "54b8",
	"./redpacket_close.svg": "7cf6",
	"./redpacket_icon.svg": "9625",
	"./redpacket_tool.svg": "b630",
	"./refresh.svg": "cb5c",
	"./reward.svg": "c225",
	"./reward_go.svg": "07dc",
	"./rewards.svg": "9ad2",
	"./row-question.svg": "fe96",
	"./same-ask-dark.svg": "2341",
	"./same-ask-light.svg": "0c68",
	"./selected-yellow.svg": "d876",
	"./selected.svg": "78d3",
	"./sensitive_icon.svg": "421c",
	"./setting.svg": "8657",
	"./shangpin.svg": "892c",
	"./share.svg": "97ed",
	"./share_active.svg": "df7b",
	"./share_active_orange.svg": "2f70",
	"./share_disabled.svg": "8964",
	"./share_orange.svg": "d3fe",
	"./silenced_icon.svg": "f7ea",
	"./single-mic-sprite.svg": "f4cc",
	"./single_bad.svg": "414d",
	"./single_better.svg": "30fd",
	"./single_moderate.svg": "9758",
	"./speaker-small-close.svg": "b00d",
	"./speaker-small.svg": "9309",
	"./speaker.svg": "03dc",
	"./spread.svg": "2481",
	"./star-blue.svg": "40a1",
	"./star-question.svg": "0e55",
	"./tip.svg": "d98d",
	"./tool.svg": "e3c9",
	"./tool_active.svg": "5b78",
	"./tool_active_orange.svg": "7916",
	"./tool_orange.svg": "7352",
	"./unfold.svg": "372f",
	"./unfold_orange.svg": "33b6",
	"./up-host-yellow.svg": "ad99",
	"./up_host.svg": "85ab",
	"./upload.svg": "c3bc",
	"./video_exitfull.svg": "b3b9",
	"./video_fullscreen.svg": "7c1d",
	"./video_hide.svg": "ddab",
	"./video_main.svg": "46af",
	"./video_main2.svg": "b702",
	"./video_max.svg": "ac49",
	"./video_show.svg": "3d9b",
	"./video_transter.svg": "3ce4",
	"./viewer.svg": "54e4",
	"./viewer_avatar.svg": "4d1ae",
	"./violation-show.svg": "fa1d",
	"./violation.svg": "1ab9",
	"./volume-close.svg": "0b3c",
	"./volume-open.svg": "7186",
	"./wechatpay.svg": "dab0",
	"./wenjuan.svg": "5fd3",
	"./whiteboard.svg": "d2b1",
	"./whiteboard_active.svg": "b895",
	"./whiteboard_active_orange.svg": "d14b",
	"./whiteboard_orange.svg": "fd99"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8dff";